const callbacks = [];

const ready = (function () {
	let callbacks;
	return function ready(fn) {
		if (typeof fn != "function") {
			console.error("ready: function expected");
			return;
		}
		switch (document.readyState) {
			case "loading":
				if (callbacks == null) {
					callbacks = [fn];
					document.addEventListener("DOMContentLoaded", () => callbacks.forEach(fn => {
						try {
							fn();
						} catch (e) {
							console.error(fn.displayName || fn.name, e);
						}
					}));
				} else {
					callbacks.push(fn);
				}
				break;
			case "interactive":
			case "complete":
				fn();
				break;
		}
	};
})();

function addCallback(f) {
	callbacks.push(f);
}

function runCallbacks() {
	while (callbacks.length)
		callbacks.shift()();
}

const Res = {};

export { addCallback, runCallbacks, Res, ready };